module.exports = __webpack_public_path__ + "img/social-share-image.100fa0ef.jpg";